"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTag(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.213 0a1.79 1.79 0 011.788 1.787v8.17c0 .765-.407 1.744-.937 2.275L12.242 23.478a1.79 1.79 0 01-2.527 0L.52 14.285a1.793 1.793 0 01.01-2.538L11.758.947C12.298.404 13.277 0 14.043 0zm0 1.532h-8.17c-.36 0-.949.244-1.213.508L1.604 12.841a.258.258 0 000 .36l9.194 9.193c.098.099.263.099.35.011L21.97 11.159c.254-.254.499-.843.499-1.201v-8.17a.258.258 0 00-.256-.256zm-4.087 1.532a2.81 2.81 0 110 5.617 2.809 2.809 0 010-5.617zm0 1.532a1.277 1.277 0 10.005 2.554 1.277 1.277 0 00-.005-2.554z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgTag;
exports.default = _default;